export default function Line(){
    return(
        <div className="border"></div>
    )
}